/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_DirectionInputs */

const cs_order_direction = /** @type {(inputs: Order_DirectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Směr`)
};

const en_order_direction = /** @type {(inputs: Order_DirectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direction`)
};

/**
* | output |
* | --- |
* | "Direction" |
*
* @param {Order_DirectionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const order_direction = /** @type {((inputs?: Order_DirectionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_DirectionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_order_direction(inputs)
	return cs_order_direction(inputs)
});